export const CHAT_BOTTOM_THRESHOLD_PX = 96;

export function isNearConversationBottom(element, threshold = CHAT_BOTTOM_THRESHOLD_PX) {
  if (!element) return true;
  const distanceFromBottom = element.scrollHeight - element.scrollTop - element.clientHeight;
  return distanceFromBottom <= Math.max(0, threshold);
}
